import React, { useState } from 'react';
import { Box, Typography, Button, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../gwmlogo.png';
import '../Header.css';

export default function Header({ user, handleLogout }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleLogout();
    handleMenuClose();
  };

  return (
    <Box className="header-container">
      <img src={Logo} alt="GasWorks Media Logo" className="header-logo" />
      <Box className="header-user">
        <Box className="header-user-desktop">
          <Button
            variant="text"
            href="/gsc"
            sx={{
              color: '#ffffff',
              marginRight: 2,
              textTransform: 'none',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: '14px',
              padding: '8px 12px',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#ffffff',
              },
            }}
          >
            GSC Chat
          </Button>
          <Button
            variant="text"
            href="#snapshots"
            sx={{
              color: '#ffffff',
              marginRight: 2,
              textTransform: 'none',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: '14px',
              padding: '8px 12px',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#ffffff',
              },
            }}
          >
            Snapshots
          </Button>
          <Typography 
            variant="body1" 
            className="user-email"
            sx={{
              color: '#ffffff',
              fontFamily: "'Inter', sans-serif",
              fontSize: '14px',
              fontWeight: 500,
            }}
          >
            {user?.email || 'Loading...'}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={handleLogout}
            className="logout-button"
            sx={{
              color: '#ffffff',
              borderColor: '#ffffff',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: '14px',
              padding: '6px 16px',
              borderRadius: '6px',
              borderWidth: '1px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderColor: '#ffffff',
                color: '#ffffff',
              },
            }}
          >
            Logout
          </Button>
        </Box>
        <IconButton
          className="header-hamburger"
          onClick={handleMenuOpen}
          sx={{ 
            color: '#ffffff',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              backgroundColor: '#1a4d3a',
              border: '1px solid #2d5e4a',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              mt: 1,
            },
          }}
        >
          <MenuItem disabled sx={{ color: '#ffffff', opacity: 0.8 }}>
            <Typography variant="body1" sx={{ fontFamily: "'Inter', sans-serif", fontSize: '14px' }}>
              {user?.email || 'Loading...'}
            </Typography>
          </MenuItem>
          <MenuItem 
            onClick={handleMenuClose}
            sx={{ 
              color: '#ffffff',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <a href="/gsc" style={{ textDecoration: 'none', color: 'inherit', fontFamily: "'Inter', sans-serif", fontSize: '14px' }}>
              GSC Chat
            </a>
          </MenuItem>
          <MenuItem 
            onClick={handleMenuClose}
            sx={{ 
              color: '#ffffff',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <a href="#snapshots" style={{ textDecoration: 'none', color: 'inherit', fontFamily: "'Inter', sans-serif", fontSize: '14px' }}>
              Snapshots
            </a>
          </MenuItem>
          <MenuItem 
            onClick={handleLogoutClick}
            sx={{ 
              color: '#ffffff',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <Typography sx={{ fontFamily: "'Inter', sans-serif", fontSize: '14px' }}>Logout</Typography>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}